class Item {
  itemObject = null;

  constructor(itemObject) {
    this.itemObject = itemObject;
    Object.freeze(itemObject);
  }

  getId() {
    throw new Error("Not Implemented");
  }

  getThumbnail() {
    throw new Error("Not Implemented");
  }

  getDescription() {
    throw new Error("Not Implemented");
  }

  getName() {
    throw new Error("Not implemented");
  }

  getQuantity() {
    throw new Error("Not Implemented");
  }

  getPrices() {
    throw new Error("Not implemented");
  }

  setQuantity() {
    throw new Error("Not Implemented");
  }

  getProductId() {
    throw new Error("Not Implemented");
  }

  getProductSku() {
    throw new Error("Not Implemented");
  }

  getProductCategories() {
    throw new Error("Not Implemented");
  }

  getProductUnitPrice() {
    throw new Error("Not Implemented");
  }
}

export default Item;
